import * as React from "react";
import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgQuestionMarkIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 24">
      <path d="M11.9997 0.333496C5.55967 0.333496 0.333008 5.56016 0.333008 12.0002C0.333008 18.4402 5.55967 23.6668 11.9997 23.6668C18.4397 23.6668 23.6663 18.4402 23.6663 12.0002C23.6663 5.56016 18.4397 0.333496 11.9997 0.333496ZM13.1663 20.1668H10.833V17.8335H13.1663V20.1668ZM15.5813 11.1252L14.5313 12.1985C13.6913 13.0502 13.1663 13.7502 13.1663 15.5002H10.833V14.9168C10.833 13.6335 11.358 12.4668 12.198 11.6152L13.6447 10.1452C14.0763 9.72516 14.333 9.14183 14.333 8.50016C14.333 7.21683 13.283 6.16683 11.9997 6.16683C10.7163 6.16683 9.66634 7.21683 9.66634 8.50016H7.33301C7.33301 5.92183 9.42134 3.8335 11.9997 3.8335C14.578 3.8335 16.6663 5.92183 16.6663 8.50016C16.6663 9.52683 16.2463 10.4602 15.5813 11.1252Z" fill="currentColor" fillRule="evenodd"/>
    </SvgIcon>
  );
};

export default SvgQuestionMarkIcon;
